import { createFileRoute } from "@tanstack/react-router";
import { ReviewsPage } from "@/app/connect/pages/reviews";

type ReviewsSearchParams = {
	provider_id?: string;
};

function cleanId(value: unknown): string | undefined {
	if (typeof value === "number") return String(value);
	if (typeof value === "string") {
		const cleaned = value.replace(/^["']|["']$/g, "");
		return cleaned || undefined;
	}
	return undefined;
}

export const Route = createFileRoute("/connect/reviews")({
	validateSearch: (search: Record<string, unknown>): ReviewsSearchParams => ({
		provider_id: cleanId(search.provider_id),
	}),
	component: ReviewsPage,
});
